const userDataFormEN = {
    "view": {
        "title": "Complete Your Information",
        "stepZero": {
            "title": "Declaration",
            "form": {
                "label": {
                    "declarationPoint1": "By providing this information, you acknowledge and agree that it will be provided to the best of your knowledge and ability. We strive to ensure that all information is accurate and truthful.",
                    "declarationPoint2": "Please be aware that providing false information or misrepresenting the truth can have significant consequences. We urge all users to verify the information they provide and to use this platform responsibly.",
                    "declarationPoint3": "The liability for any misinformation or errors lies solely with the individual providing the information. We assume no responsibility for the consequences of incorrect or misleading information provided by users.",
                    "declarationPoint4": "By clicking <strong>'Next'</strong>, you consent to these terms and affirm that you are fully aware of the implications of providing inaccurate or false information.",
                    "declarationAgreement": "I fully agree and understand the terms above."
                },
                "button": {
                    "next": "Next"
                }
            }
        },
        "stepOne": {
            "title": "Personal Information",
            "form": {
                "label": {
                    "firstName": "First Name",
                    "lastName": "Last Name",
                    "streetAndNumber": "Street and Number",
                    "zipCode": "ZIP Code",
                    "city": "City",
                    "country": "Country"
                },
                "placeholder": {
                    "country": "Select Country"
                },
                "help_text": {
                    "firstName": "If registering as an LLC or other business entity, this field will be used for the CEO's First Name.",
                    "lastName": "If registering as an LLC or other business entity, this field will be used for the CEO's Last Name.",
                    "country": "If registering as an LLC or other business entity, this field will be used for the CEO's Country."
                },
                "button": {
                    "next": "Next"
                }
            }
        },
        "stepTwo": {
            "title": "Business Information",
            "form": {
                "label": {
                    "businessType": "Business Type",
                    "companyName": "Company Name",
                    "businessStreet": "Street and Number",
                    "businessCity": "City",
                    "businessZip": "ZIP Code",
                    "businessCountry": "Country",
                    "ceoFirstName": "Legal Representative / CEO First Name",
                    "ceoLastName": "Legal Representative / CEO Last Name",
                    "tradeRegistryExport": "Trade Registry Export",
                    "tradeRegistryCompanyUrl": "Trade Registry Company URL",
                    "vatNumber": "VAT Number",
                    "taxNumber": "Tax Number"
                },
                "option": {
                    "businessType": {
                        "soleProprietorship": "Sole proprietorship",
                        "limitedLiabilityCompany": "Limited liability company",
                        "partnershipOrganized": "Partnership organized",
                        "publicLimitedCompanyByShares": "Public limited company by shares",
                        "other": "Other"
                    }
                },
                "placeholder": {
                    "businessType": "Select Business Type",
                    "businessCountry": "Select Country"
                },
                "help_text": {
                    "companyName": "Company name should be consistent with what was initially submitted in Stripe. Only change if it differs from what was initially submitted.",
                    "tradeRegistryExport": "Please provide an official trade registry export of your company. PDF only, max file size 5 MB. If you need help with finding your trade registry export, please contact the registry in your country. An unofficial list of the registries can be found <1>here</1>.",
                    "tradeRegistryCompanyUrl": "Please provide your company URL at your country's trade registry. If your registry does not support this, please insert a registry URL only."
                },
                "button": {
                    "previous": "Previous",
                    "next": "Next"
                }
            }
        },
        "stepThree": {
            "title": "Confirmation",
            "form": {
                "label": {
                    "personalInformation": "Personal Information",
                    "personalName": "Name",
                    "personalAddress": "Address",
                    "businessInformation": "Business Information",
                    "companyName": "Company",
                    "ceoName": "CEO Name",
                    "businessAddress": "Address",
                    "businessType": "Business Type",
                    "taxNumber": "Tax Number",
                    "vatNumber": "VAT Number",
                    "tradeRegistryExportUploaded": "Trade Registry Export Uploaded",
                    "tradeRegistryCompanyUrl": "Trade Registry Company URL",
                    "notAvailable": "N/A"
                },
                "button": {
                    "previous": "Previous",
                    "save": "Save",
                    "next": "Next"
                }
            },
            "message": {
                "success": "Your information has been updated!",
                "error": "Something went wrong! Please refresh page and try again!"
            },
            "modal": {
                "submitYourInformation": {
                    "header": "Submit Your Information",
                    "body": {
                        "point1": "By clicking <strong>'Confirm'</strong>, you are affirming that all the information you have provided is accurate and truthful to the best of your knowledge.",
                        "point2": "Do you confirm that all the details provided are correct and acknowledge the potential consequences of submitting inaccurate information?",
                    },
                    "button": {
                        "confirm": "Confirm",
                        "cancel": "Cancel"
                    }
                }
            }
        },
        "stepFour": {
            "title": "Verify Mobile Number",
            "form": {
                "label": {
                    "mobileNumber": "Enter Your Mobile Number",
                    "deliveryMedium": "Delivery Medium: ",
                    "deliveryMediumSMS": "SMS",
                    "deliveryMediumWhatsapp": "WhatsApp",
                    "otp": "OTP"
                },
                "help_text": {
                    "mobileNumber": "Note: Mobile Number is required for verification as standard procedure because it can be used for login validation. You need to own the number and have access to it for smooth verification process.",
                    "isFormUSorCanada": "* If you are US or Canada based, please contact our support team after inserting your mobile number.",
                    "deliveryMediumWhatsapp": "Note: Please ensure that you have a WhatsApp account on this number in order to receive the message.",
                    "otp": "Please enter the OTP sent to your mobile number."
                },
                "message": {
                    "errorMobileNumberEmpty": "Mobile Number is required.",
                    "errorMobileNumberInvalid": "Invalid mobile number.",
                    "errorMobileNumberSame": "This number is already added and verified with your account.",
                    "errorOTPRequired": "OTP is required.",
                    "errorOtpSendLimitExhasuted": "You can not request any more OTP's as you have exhausted the <strong>MAX limit ({{maxLimit}})</strong> for OTP requests. Please contact support for further information!",
                    "errorMobileUpdateLimitExhausted": "You can not update your mobile number as you have already updated it MAX ({{maxLimit}}) times. Please contact support for further information!",
                },
                "button": {
                    "sendOTP": "Send OTP",
                    "next": "Next",
                    "confirm": "Confirm",
                    "notGettingCode": "I am not getting the code"
                }
            },
            "message": {
                "success": "Mobile number verified!",
                "errorValidatingOTP": "Error in validating OTP!",
                "errorSendingOTP": "There was an issue in sending OTP code, please try again later!",
            },
            "modal": {
                "notGettingCode": {
                    "header": "I am not getting the code",
                    "body": {
                        "point1": "Looks like there’s a problem sending you a verification code right now. Please try again later",
                        "point2": "For assistance, please reach out to our support via Help Center."
                    },
                    "button": {
                        "close": "Close"
                    }
                }
            },
            "resendTimer": {
                "message": {
                    "secondsRemaining": "You can request the OTP again in <strong>{{secondsRemaining}}</strong> seconds"
                }
            }
        },
        "stepFive": {
            "title": "Identity Verification",
            "form": {
                "label": {
                    "identityVerificationDescription": "Please click on the link below to start Identity Verification.",
                    "identityVerificationResults": "Identity Verification Results",
                },
                "button": {
                    "loading": "Loading...",
                    "verifyIdentity": "Verify Identity"
                },
                "table": {
                    "column": {
                        "type": "Type",
                        "status": "Status",
                        "details": "Details"
                    },
                    "label": {
                        "selfieVerification": "Selfie Verification",
                        "documentVerification": "Document Verification",
                        "verified": "Verified",
                        "notVerified": "Not Verified",
                        "notAvailable": "N/A"
                    }
                },
                "message": {
                    "identityVerificationSuccess": "Your identity information has been verified, our team will review the identity information and give the final approval in 2-3 business days.",
                    "identityVerificationFailed": "Your identity information could not be verified, kindly submit the information again! You only have <strong>{{attemptsRemaining}}</strong> attempt remaining to verify your identity.",
                    "identityVerificationMaxAttempts": "You have exhausted the maximum number of attempts for Identity Verification, please contact support for further information."
                }
            }
        },
        "stepSix": {
            "title": "Sign Contract",
            "form": {
                "label": {
                    "signContract": "Sign Contract"
                }
            }
        },
        "stepSeven": {
            "title": "Approval",
            "form": {
                "message": {
                    "approval": "Our team will review all the information provided by you and give the final approval within 3 business days."
                }
            }
        },
    },
    "signRedirectPages": {
        "signSuccess": {
            "title": "Contract Sign Successful :)",
            "description": "You have successfully signed your contract, the status will be updated in your account shortly, please refresh the page in few seconds.",
        },
        "signLater": {
            "title": "Contract Sign Later ...",
            "description": "You have chosen to sign the contract later, please complete this step at the earliest to avail distribution.",
        },
        "signDeclined": {
            "title": "Contract Sign Declined :(",
            "description": "You have declined to sign the contract, this will delay the process to enable distribution.",
        },
        "signCompleted": {
            "title": "Contract Sign Completed :)",
            "description": "Your contract has been finalized, the status will be updated in your account shortly, please refresh the page in few seconds.",
        }
    }
};

export default userDataFormEN;
